import React from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../components/layouts/Layout';
import SEO from '../components/seo';

export const Terms = ({ user, notification, actions }) => {
    return (
        <Layout user={user} notification={notification} actions={actions}>
            <SEO title="Terms of Use" />
            <div className="content-container legal">
                <div className="row">
                    <div className="col-md-10 col-md-offset-1">
                        <h2>Terms of Use</h2>
                        <div className="media">
                            <p>
                                These "Terms of Use" set forth the terms and
                                conditions that apply to your use of the Second
                                Chance Bonus Zone&reg; (the "Website"). By using the
                                Website (other than to read this page for the
                                first time), you agree to comply with all of the
                                Terms of Use set forth herein. The Website is
                                owned by MDI Entertainment, LLC ("MDI
                                Entertainment"), a Scientific Games company, and
                                is provided for the sole purpose of
                                administering services on behalf of the South
                                Carolina Education Lottery (the "Lottery"). The
                                right to use the Website is personal to you and
                                is not transferable to any other person or
                                entity. Participants in Twelve Weeks of Holiday Winnings 2ND
                                Chance Drawing (the "Second Chance Promotion")
                                from the Illinois Lottery, and all participants'
                                submissions are subject to the Privacy Policy
                                that governs the Second Chance Promotion.
                            </p>
                            <h2>Copyright</h2>
                            <p>
                                The materials found on the Website are protected
                                by United States and other copyright laws,
                                except for works of the United States Government
                                pursuant to 1 U.S.C. Section 105. The selection,
                                arrangement and presentation of all materials
                                (including information in the public domain),
                                and the overall design of the Website are
                                copyright ©2017 MDI Entertainment. Permission is
                                granted to view and print materials from the
                                Second Chance Bonus Zone&reg; for the non-commercial
                                purpose of viewing, reading and retaining for
                                reference. Any other copying, distribution,
                                retransmission or modification of information or
                                materials on this site, whether in electronic or
                                hard copy form, without the express prior
                                written permission of MDI Entertainment is
                                strictly prohibited.
                            </p>
                            <h2>Trademarks</h2>
                            <p>
                                Second Chance Bonus Zone® and other trademarks
                                and/or service marks (including logos and
                                designs) found on the Website are
                                trademarks/service marks that identify MDI
                                Entertainment, the government lottery for whose
                                benefit and the benefit of its customers the
                                Website is produced, the intellectual property
                                of one or more companies with whom MDI
                                Entertainment has licensing agreements in place,
                                and the goods and/or services provided by MDI
                                Entertainment (collectively, the "Marks"). Such
                                Marks may not be used under any circumstances
                                without the prior written authorization of MDI
                                Entertainment or the other appropriate owners of
                                the intellectual property.
                            </p>
                            <h2>License and Site Access</h2>
                            <p>
                                MDI Entertainment grants you a non-exclusive,
                                revocable, limited license to access and make
                                personal use of this Website and not to download
                                (other than page caching) or modify it, or any
                                portion of it, except with the prior written
                                consent of MDI Entertainment. This license does
                                not include any resale or commercial use of this
                                Website or its content; any derivative use of
                                this Website or its content; any downloading or
                                copying of account information for the benefit
                                of a third party; or any use of data mining,
                                robots, or similar data gathering and extraction
                                tools. This Website or any portion of this
                                Website shall not be reproduced, duplicated,
                                mirrored, copied, sold, resold, or otherwise
                                exploited for any commercial purpose without the
                                prior written consent of MDI Entertainment. You
                                shall not frame or utilize framing techniques to
                                enclose any Marks or other proprietary
                                information (including images, text, page
                                layout, or form) of this Website or mirror this
                                Website without the prior written consent of MDI
                                Entertainment. You shall not use any metatags or
                                any other "hidden text" utilizing MDI
                                Entertainment's name or any Marks without the
                                prior written consent of MDI Entertainment or
                                the respective authorized parties. Any
                                unauthorized use shall terminate the permission
                                or license granted by MDI Entertainment herein.
                                You shall not use any MDI Entertainment name,
                                logo, Marks or other proprietary graphic or
                                trademark as part of a link without the prior
                                written consent of MDI Entertainment.
                            </p>
                            <h2>Links to Third-Party Websites</h2>
                            <p>
                                MDI Entertainment may provide hyperlinks to
                                third-party websites as a convenience to users
                                of the Website. MDI Entertainment does not
                                control third-party websites and is not
                                responsible for the contents of any linked-to,
                                third-party websites or any hyperlink in a
                                linked-to website. MDI Entertainment does not
                                endorse, recommend or approve any third-party
                                website hyperlinked from the Website. MDI
                                Entertainment will have no liability to any
                                entity for the content or use of the content
                                available through such hyperlink.
                            </p>
                            <h2>Age Restrictions</h2>
                            <p>
                                The Website is not directed to persons under
                                eighteen (18) years of age, and individuals
                                under such age must not use the Website,
                                participate in any Second Chance Promotion,
                                submit any personally identifiable information
                                through the Website or use the offered services
                                in any way.
                            </p>
                            <h2>No Warranties</h2>
                            <p>
                                MDI ENTERTAINMENT AND THE LOTTERY MAKE NO
                                EXPRESS OR IMPLIED WARRANTIES, REPRESENTATIONS
                                OR ENDORSEMENTS WHATSOEVER (INCLUDING, WITHOUT
                                LIMITATION, THE IMPLIED WARRANTIES OF
                                MERCHANTABILITY OR FITNESS FOR A PARTICULAR
                                PURPOSE) WITH REGARD TO THE WEBSITE, ANY
                                MATERIALS, INFORMATION OR SERVICE PROVIDED
                                THROUGH THE WEBSITE, OR ANY OTHER SITES LISTED
                                THEREIN. MDI ENTERTAINMENT AND THE LOTTERY DO
                                NOT WARRANT THAT THE WEBSITE WILL BE
                                UNINTERRUPTED OR ERROR-FREE OR THAT DEFECTS IN
                                IT WILL BE CORRECTED. THE WEBSITE IS PROVIDED ON
                                AN "AS IS, AS AVAILABLE" BASIS.
                            </p>
                            <h2>Limitation of Liability</h2>
                            <p>
                                IN NO EVENT WILL MDI ENTERTAINMENT, THE LOTTERY,
                                OR ANY OF THEIR RESPECTIVE PARENTS,
                                SUBSIDIARIES, AFFILIATES, OFFICERS, DIRECTORS,
                                SHAREHOLDERS, PARTNERS, EMPLOYEES, AGENTS, AND
                                REPRESENTATIVES BE LIABLE FOR ANY DIRECT,
                                INDIRECT, INCIDENTAL, CONSEQUENTIAL OR SPECIAL
                                DAMAGES (INCLUDING, BUT NOT LIMITED TO, DAMAGES
                                FOR LOSS OF PROFITS, BUSINESS INTERRUPTION, LOSS
                                OF PROGRAMS OR INFORMATION, AND THE LIKE)
                                ARISING OUT OF (1) THE USE OF OR INABILITY TO
                                USE THE WEBSITE OR ANY INFORMATION, MATERIALS OR
                                TRANSACTIONS PROVIDED ON THE WEBSITE OR
                                DOWNLOADED FROM THE WEBSITE, OR (2) ANY CLAIM
                                ATTRIBUTABLE TO ERRORS, OMISSIONS OR OTHER
                                INACCURACIES IN THE WEBSITE OR ANY MATERIALS OR
                                INFORMATION DOWNLOADED THROUGH THE WEBSITE, EVEN
                                IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
                                SOME STATES DO NOT ALLOW THE EXCLUSION OR
                                LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR
                                INCIDENTAL DAMAGES. ACCORDINGLY, SOME OR ALL OF
                                THE ABOVE LIMITATIONS MAY NOT APPLY TO YOU.
                            </p>
                            <h2>Indemnification</h2>
                            <p>
                                You agree to indemnify, defend and hold harmless
                                MDI Entertainment, the Lottery, and all of their
                                respective parents, subsidiaries, affiliates,
                                officers, directors, shareholders, partners,
                                employees, agents, and representatives, from and
                                against any and all loss, costs, expenses
                                (including reasonable attorneys' fees and
                                expenses), claims, damages and liabilities
                                related to or associated with your use of the
                                Website and any breach or violation of this
                                Terms of Use by you.
                            </p>
                            <h2>Governing Law</h2>
                            <p>
                                By visiting the Website, you agree that the laws
                                of the State of South Carolina, without regard
                                to principles of conflict of laws, shall govern
                                these Terms of Use and any dispute of any sort
                                that might arise between or among you, MDI
                                Entertainment and the Lottery.
                            </p>
                            <h2>Changes to These Terms of Use </h2>
                            <p>
                                MDI Entertainment reserves the right to change
                                these Terms of Use at any time by posting new
                                Terms of Use at this location. Your continued
                                use of the Website shall constitute your
                                acceptance of such new Terms of Use. These Terms
                                of Use were last modified on July 31, 2017.
                            </p>
                            <h2>Contact</h2>
                            <p>
                                Questions or comments regarding the Website
                                should be sent by email using the <a href="feedback"><strong>Feedback</strong></a> form
                                at this website, if applicable, or by U.S. mail
                                to: Digital Content Studio Manager, Scientific
                                Games Lottery, 1500 Bluegrass Lakes Parkway,
                                Alpharetta, Georgia 30004.
                            </p>
                            <p>
                                <strong>
                                    Promotion void where prohibited by law.
                                </strong>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Terms);
